import { CONNECT, SETTINGS } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export const requireConnection = (store, redirectTo) => (nextState, replace, callback) => {
  const state = store.getState();
  const shopifyConnectionState = state.shopify.shopifyConnectionState;

  if (shopifyConnectionState === CONNECT) {
    replace({
      pathname: `${redirectTo}/${CONNECT}`,
      state: { nextPathname: nextState.location.pathname },
    });
  }

  return callback();
};

// eslint-disable-next-line import/prefer-default-export
export const requireSettings = (store, redirectTo) => (nextState, replace, callback) => {
  const state = store.getState();
  const shopifyConnectionState = state.shopify.shopifyConnectionState;

  if (shopifyConnectionState === SETTINGS) {
    replace({
      pathname: `${redirectTo}/${SETTINGS}`,
      state: { nextPathname: nextState.location.pathname },
    });
  }

  return callback();
};
